import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import anime from 'animejs/lib/anime.es.js';
import Logo from "./logos/litproLogo2.png";
import menuIcon from "./logos/menuIcon.png";
import { useMediaQuery } from 'react-responsive';

export default function Header() {
  const animation = useRef(null);
  const menuAnimation = useRef(null);
  const [showMobileMenu, setShowMobilMenu] = useState(false);

  const isMobile = useMediaQuery({
      query: '(max-width: 1200px)'
  });

  function toggleMobileMenu() {
    setShowMobilMenu(prev => !prev);
  }

  useEffect(() => {
    // Mobile menu animation
    if (showMobileMenu) {
      menuAnimation.current = anime({
        targets: ".mobile-menu li",
        translateY: [-100, 0],
        opacity: [0, 1],
        duration: 1000,
        loop: false,
        delay: anime.stagger(100),
        easing: "easeOutExpo"
      })
    }

    menuAnimation.current = anime({
        targets: ".show-menu",
        opacity: [0, 1],
        duration: 2000,
        delay: 100,
        loop: false,
        easing: "easeOutExpo"
      })
  })

    useEffect(() => {
    animation.current = anime.timeline({
      targets: "#logo-frame-1, #logo-frame-2, #header-logo-line, #logo, #logo-frame-shadow",
      duration: 1000,
      loop: false,
    })

    // Spin borders
    animation.current.add({
      targets: '#logo-frame-1, #logo-frame-2',
      rotate: '1turn',
      scale: [{
        value: [1, 1.1]
      }, {
        value: [1.1, 1],
        delay: 500,
      }],
      duration: 1500,
      delay: 500,
      easing: "easeInOutExpo"
    })

    // Open line
    animation.current.add({
      targets: '#header-logo-line',
      opacity: 1,
      scaleX: [
        {
        value: [0, 1],
        easing: "easeInOutExpo",
      },
      {
        value: [1, 0],
        easing: "easeInOutExpo",
        duration: 1000
      }],
      translateY: [
        {
        value: "-70px",
        easing: "easeInOutExpo",
      }]
    })

    // Show logo
    animation.current.add({
      targets: '#logo',
      opacity: 1,
      easing: "easeInOutExpo",
    }, '-=1200')

    // Add shadow
    animation.current.add({
      targets: '#logo-frame-shadow',
      opacity: "1",
      duration: 250,
      easing: "easeInOutExpo"
    })

    
  }, []);

  return (
    <div id="nav-container">
      {/* Logo */}
      <Link to="/">
      <div id="logo-container">
      <div className="left-side-logo">
        <img id="logo" src={ Logo } alt="LitPro Logo"/>
        <div id="header-logo-line"></div>
      </div>
      <div id="logo-frame-1">
      <div id="logo-frame-2">
      <div id="logo-frame-shadow">
      </div>
      </div>
      </div>
      </div>
      </Link>
      { isMobile && <img className="headerMenuIcon" src={menuIcon} alt="menu" onClick={() => toggleMobileMenu()}></img>}
      <div className="left-side">
      {/* Public Links */}
      <ul className="nav-bar">
        <Link to="/">
          <li>Home</li>
        </Link>
        <Link to="/about">
          <li>Learn More</li>
        </Link>
        <Link to="/contact">
          <li>Reach Out</li>
        </Link>
        <Link to="/pricing">
          <li>Pricing</li>
        </Link>
      </ul>
      </div>

      {/* Mobile Menu */}
      { showMobileMenu && 
      <>
      <div className="left-side">
      {/* Public Links */}
      <ul className="nav-bar show-menu mobile-menu">
        <Link to="/">
          <li>Home</li>
        </Link>
        <Link to="/about">
          <li>Learn More</li>
        </Link>
        <Link to="/contact">
          <li>Reach Out</li>
        </Link>
        <Link to="/pricing">
          <li>Pricing</li>
        </Link>
      </ul>
      </div>
      </>
      }
    </div>
  );
}
